var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.625 7.71874C12.625 9.99692 10.7782 11.8437 8.5 11.8437C6.22183 11.8437 4.375 9.99692 4.375 7.71874C4.375 5.44057 6.22183 3.59374 8.5 3.59374C10.7782 3.59374 12.625 5.44057 12.625 7.71874ZM13.375 7.71874C13.375 10.4111 11.1924 12.5937 8.5 12.5937C5.80761 12.5937 3.625 10.4111 3.625 7.71874C3.625 5.02635 5.80761 2.84374 8.5 2.84374C11.1924 2.84374 13.375 5.02635 13.375 7.71874ZM5.87503 7.34369C5.66792 7.34369 5.50003 7.51158 5.50003 7.71869C5.50003 7.92579 5.66792 8.09369 5.87503 8.09369H11.125C11.3321 8.09369 11.5 7.92579 11.5 7.71869C11.5 7.51158 11.3321 7.34369 11.125 7.34369H5.87503Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableDelete);
export default __webpack_public_path__ + "static/media/table-delete.0669f1be807f6253e8d73bc98c696ece.svg";
export { ForwardRef as ReactComponent };